/*!
 * SuperNutriOmni / Dropmeta Classic — otimizações compatíveis
 * - Substitui rotinas duplicadas do antigo custom.aio.min.js
 * - Agrupa leituras e escritas no DOM para reduzir reflows
 * - Evita polling e MutationObserver em ciclo próprio
 * - Preserva parcelamento, estado dos botões, quantidade e aviso de preço
 */
(function () {
  'use strict';

  var raf = window.requestAnimationFrame || function (callback) { return window.setTimeout(callback, 16); };
  var scheduled = false;
  var lastPriceSignature = '';

  function query(selector, root) {
    return (root || document).querySelector(selector);
  }

  function queryAll(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function parseMoney(text) {
    if (!text) return NaN;

    var normalized = String(text)
      .replace(/\u00a0/g, ' ')
      .replace(/[^0-9,.-]/g, '')
      .trim();

    if (!normalized) return NaN;

    var hasComma = normalized.indexOf(',') !== -1;
    var hasDot = normalized.indexOf('.') !== -1;

    if (hasComma) {
      normalized = normalized.replace(/\./g, '').replace(',', '.');
    } else if (hasDot) {
      var parts = normalized.split('.');
      if (parts.length > 2) normalized = parts.join('');
    }

    var value = Number.parseFloat(normalized);
    return Number.isFinite(value) ? value : NaN;
  }

  function getCleanPriceText(element) {
    if (!element) return '';
    var clone = element.cloneNode(true);
    queryAll('.product-label, .sn-sale-percent, .preco-referencia', clone).forEach(function (node) {
      node.remove();
    });
    return (clone.textContent || '').trim();
  }

  function formatBRL(value) {
    if (!Number.isFinite(value)) return '';
    try {
      return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    } catch (error) {
      return 'R$ ' + value.toFixed(2).replace('.', ',');
    }
  }

  function formatNumber(value) {
    if (!Number.isFinite(value)) return '';
    return value.toFixed(2).replace('.', ',');
  }

  function setText(selector, text) {
    queryAll(selector).forEach(function (element) {
      if (element.textContent !== text) element.textContent = text;
    });
  }

  function readPaymentState() {
    var highlightElement = query('.product-form__info-item .price--highlight') || query('.price--highlight');
    var regularElement = query('.product-form__info-item .price-without-discount') || query('.price-without-discount');
    var compareElement = query('.product-form__info-item .price--compare') || query('.price--compare');
    var currentElement = highlightElement || regularElement;

    var priceText = getCleanPriceText(currentElement);
    var compareText = getCleanPriceText(compareElement);
    var price = parseMoney(priceText);
    var comparePrice = parseMoney(compareText);

    var pixTextElement = query('.product-form__info-item .product-pix') || query('.product-pix');
    var pixPercentMatch = pixTextElement ? (pixTextElement.textContent || '').match(/([0-9]+(?:[.,][0-9]+)?)\s*%/) : null;
    var cashDiscountPercent = pixPercentMatch ? parseMoney(pixPercentMatch[1]) : 0;

    var modalPixDescription = query('.modal-parcel-price-description-pix');
    var modalPercentMatch = modalPixDescription ? (modalPixDescription.textContent || '').match(/([0-9]+(?:[.,][0-9]+)?)/) : null;
    var pixDiscountPercent = modalPercentMatch ? parseMoney(modalPercentMatch[1]) : cashDiscountPercent;

    return {
      price: price,
      comparePrice: comparePrice,
      cashDiscountPercent: Number.isFinite(cashDiscountPercent) ? cashDiscountPercent : 0,
      pixDiscountPercent: Number.isFinite(pixDiscountPercent) ? pixDiscountPercent : 0,
      signature: [priceText, compareText, cashDiscountPercent, pixDiscountPercent].join('|')
    };
  }

  function writePaymentState(state) {
    if (!state || !Number.isFinite(state.price)) return;

    var price = state.price;
    var comparePrice = state.comparePrice;
    var saleLabelSpan = query('.product-label.product-label--on-sale span');
    var saleLabelInsidePrice = query('.price--highlight .product-label.product-label--on-sale');

    if (Number.isFinite(comparePrice) && comparePrice > price) {
      var difference = comparePrice - price;
      var percent = Math.floor((100 * difference) / comparePrice);

      if (saleLabelSpan) saleLabelSpan.textContent = formatBRL(difference);

      if (saleLabelInsidePrice) {
        var percentElement = query('.sn-sale-percent', saleLabelInsidePrice);
        if (!percentElement) {
          percentElement = document.createElement('span');
          percentElement.className = 'sn-sale-percent';
          saleLabelInsidePrice.appendChild(percentElement);
        }
        percentElement.textContent = '-' + percent + '%';
      }
    } else {
      queryAll('.sn-sale-percent').forEach(function (element) { element.remove(); });
    }

    var installmentTotal = price * 1.1979;
    var installment12 = installmentTotal / 12;
    var installmentElement = query('.parcelamento');
    if (installmentElement) {
      var installmentHTML = '<span>em até 12x de <b>' + formatBRL(installment12) + '</b></span>';
      if (installmentElement.innerHTML !== installmentHTML) installmentElement.innerHTML = installmentHTML;
    }

    var cashPrice = price - (price * state.cashDiscountPercent / 100);
    var pixPrice = price - (price * state.pixDiscountPercent / 100);

    setText('#total-a-vista, .total-a-vista', formatBRL(cashPrice));
    setText('#total-boleto', formatBRL(cashPrice));
    setText('#total-pix', formatBRL(pixPrice));

    for (var count = 2; count <= 12; count += 1) {
      var totalText = formatBRL(installmentTotal);
      var installmentText = formatBRL(installmentTotal / count);
      setText('#total-parcelado-' + count + 'x, .total-parcelado-' + count + 'x', totalText);
      setText('#total-' + count + 'x, .total-' + count + 'x', installmentText);
    }
  }

  function updatePaymentInformation(force) {
  if (window.location.pathname.indexOf('/en-us') === 0) return;

  var state = readPaymentState();
    if (!Number.isFinite(state.price)) return;
    if (!force && state.signature === lastPriceSignature) return;
    lastPriceSignature = state.signature;
    raf(function () { writePaymentState(state); });
  }

  function scheduleProductUpdate(force) {
    if (scheduled) return;
    scheduled = true;
    raf(function () {
      scheduled = false;
      updatePaymentInformation(Boolean(force));
      checkButtonStatus();
    });
  }

  function checkButtonStatus() {
    var addButton = query('.product-form__add-button');
    var quantitySelector = query('.display-align-btn-add-qty');
    var cartButton = query('.add-to-cart-style');
    if (!addButton) return;

    var label = (addButton.textContent || '').trim().toLowerCase();
    var soldOut = Boolean(addButton.disabled) || /esgotado|sold out|agotado/.test(label);

    if (cartButton) {
      cartButton.style.display = soldOut ? 'none' : 'inline-block';
      cartButton.style.textAlign = 'center';
    }
    if (quantitySelector) quantitySelector.style.display = soldOut ? 'none' : 'flex';
  }

  function changeNumberValue(delta) {
    var input = document.getElementById('number');
    if (!input) return;
    var value = Number.parseInt(input.value, 10);
    if (!Number.isFinite(value)) value = 0;
    value = Math.max(1, value + delta);
    input.value = String(value);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function bindPriceObserver() {
    var priceRoot = query('.product-form__info-list') || query('.product-form__info-item');
    if (!priceRoot || !('MutationObserver' in window)) return;

    var observer = new MutationObserver(function () {
      scheduleProductUpdate(false);
    });

    observer.observe(priceRoot, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  function bindVariantChanges() {
    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (target.matches('.block-swatch__radio, .variant-swatch__radio, .product-form__single-selector, [name="id"]')) {
        window.setTimeout(function () { scheduleProductUpdate(true); }, 120);
      }
    });

    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest ? event.target.closest('.block-swatch, .variant-swatch, [data-action="select-value"]') : null;
      if (target) window.setTimeout(function () { scheduleProductUpdate(true); }, 120);
    });
  }

  function bindScrollButton() {
    var element = document.getElementById('scrollToTop');
    if (!element || element.getAttribute('data-sn-scroll-bound') === 'true') return;
    element.setAttribute('data-sn-scroll-bound', 'true');

    var ticking = false;
    function renderScrollState() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      var desiredDisplay = scrollTop > 1200 ? 'block' : 'none';
      if (element.style.display !== desiredDisplay) element.style.display = desiredDisplay;
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      raf(renderScrollState);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    renderScrollState();
  }

  function normalizeCollectionUrl() {
    if (window.location.pathname === '/collections/all' && window.location.search === '?sort_by=best-selling') {
      window.location.replace('/collections/all');
    }
  }

  function hideLoaders() {
    queryAll('.loader').forEach(function (loader) { loader.hidden = true; });
  }

  function initialize() {
    normalizeCollectionUrl();
    hideLoaders();
    updatePaymentInformation(true);
    checkButtonStatus();
    bindVariantChanges();
    bindPriceObserver();

    if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) bindScrollButton();

    document.addEventListener('shopify:section:load', function () {
      scheduleProductUpdate(true);
      bindScrollButton();
    });
  }

  window.increaseValue = function () { changeNumberValue(1); };
  window.decreaseValue = function () { changeNumberValue(-1); };
  window.parcelamento = function () { updatePaymentInformation(true); };
  window.checkButtonStatus = checkButtonStatus;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
}());
